import React, { useEffect, useState } from 'react';
import styles from "./Potable.module.css";
import styless from '../allEnquiresTab/specificationsTab.module.css';
import { Refresh } from '../../../../Svg';
import Calendar from 'react-calendar/dist/cjs/Calendar.js';
import 'react-calendar/dist/Calendar.css';
import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { formateDate } from '../../../../Website/utils/utils';
import api from '../../../../Website/utils/api';
import { setScheduleOrderRefresh } from '../../../../Website/redux/scheduleOrderSlice';
import { useDispatch } from 'react-redux';

const ActionButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    marginRight: theme.spacing(1),
    fontSize: '14px',
    '&:hover': {
        backgroundColor: theme.palette.grey[200],
    },
}));

// Product photo, or a plain chip placeholder when there is no photo (same as the PO table)
const ProductThumb = ({ src }) => {
    const [failed, setFailed] = useState(false);
    return (
        <div style={{ width: 44, height: 44, borderRadius: 8, border: '1px solid #e2e8f0', background: '#f8fafc', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', flexShrink: 0, padding: 4 }}>
            {(!src || failed) ? (
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <rect x="6" y="6" width="12" height="12" rx="2" />
                    <path d="M9 2v4M15 2v4M9 18v4M15 18v4M2 9h4M2 15h4M18 9h4M18 15h4" />
                </svg>
            ) : (
                <img src={src} alt="" style={{ width: '100%', height: '100%', objectFit: 'contain' }} onError={() => setFailed(true)} />
            )}
        </div>
    );
};

const Reschedulecomp = ({ data }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [showCalendar, setShowCalendar] = useState("");
    const [rescheduleData, setRescheduleData] = useState({});
    const { id } = useParams()
    const [loading, setLoading] = useState(false)
    const [quantityErrors, setQuantityErrors] = useState({});

    const handleCalClick = (id) => {
        setShowCalendar(prevState => (prevState === id ? "" : id));
    };

    const validateQuantity = (productNumber, value) => {
        const numValue = Number(value);

        if (value === '' || isNaN(numValue)) {
            setQuantityErrors(prev => ({ ...prev, [productNumber]: 'Please enter a valid number' }));
            return false;
        }

        if (numValue <= 0) {
            setQuantityErrors(prev => ({ ...prev, [productNumber]: 'Quantity must be greater than 0' }));
            return false;
        }

        setQuantityErrors(prev => ({ ...prev, [productNumber]: '' }));
        return true;
    };

    const handleQuantityChange = (e, productId) => {
        const value = e.target.value;
        setRescheduleData(prev => ({
            ...prev,
            [productId]: {
                ...prev[productId],
                rescheduledQuantity: Number(value),
            },
        }));

        validateQuantity(productId, value)
    };


    useEffect(() => {
        setQuantityErrors({});
    }, [data.length]);

    // Earliest reschedule date the server accepts (2 days from today)
    const minRescheduleDate = (() => { const d = new Date(); d.setDate(d.getDate() + 2); d.setHours(0, 0, 0, 0); return d; })();

    const handleDateChange = (date, productId) => {
        setRescheduleData(prev => ({
            ...prev,
            [productId]: {
                ...prev[productId],
                rescheduleDate: date,
            },
        }));
        setShowCalendar("");
    };


    const handleDispatch = async () => {
        // Only the rows the customer filled in are rescheduled; untouched rows stay as they are.
        // A row with only a quantity or only a date is incomplete and blocks the submit.
        const partName = (item) => item?.productId?.productOverview?.productNumber?.[0] || item?.productNumber || "Unknown Product";
        const incomplete = [];
        const toReschedule = [];

        const qtyFor = {};
        data.forEach(item => {
            const entry = rescheduleData[item._id] || {};
            const hasDate = Boolean(entry.rescheduleDate);
            // A date without a quantity means "reschedule the whole pending quantity"
            const qty = Number(entry.rescheduledQuantity) > 0
                ? Number(entry.rescheduledQuantity)
                : (hasDate ? Number(item?.pendingOrderCount ?? item?.quantity) || 0 : 0);
            if (hasDate && qty > 0) { qtyFor[item._id] = qty; toReschedule.push(item); }
            else if (qty > 0 && !hasDate) incomplete.push(partName(item));
        });

        if (incomplete.length > 0) {
            toast.error(`Please pick a reschedule date for:\n\n${incomplete.join('\n')}`);
            return;
        }
        if (toReschedule.length === 0) {
            toast.error("Enter the required quantity and a reschedule date for at least one part");
            return;
        }

        const finalPayload = toReschedule.map(item => ({
            productId: item.productId ? (item.productId._id || item.productId) : "",
            productNumber: item?.productId?.productOverview?.productNumber?.[0] || item?.productNumber || "",
            rescheduleDate: rescheduleData[item._id]?.rescheduleDate,
            rescheduledQuantity: qtyFor[item._id],
        }));

        console.log("Final Payload:", finalPayload);
        const finaldata = {
            id,
            products: finalPayload
        }
        setLoading(true)
        try {
            const response = await api.rescheduleOrder(finaldata)
            if (response.data) {
                toast.success("Order rescheduled successfully")
                dispatch(setScheduleOrderRefresh())
                navigate(-1)
            }
        } catch (err) {
            console.log(err);
            toast.error(err?.response?.data?.message || "something went wrong")

        } finally {
            setLoading(false)
        }

    };


    // Reset/clear the reschedule data state when "Cancel" is clicked.
    const handleCancel = () => {
        setRescheduleData({});
        setShowCalendar("");
    };

    const handleRefresh = (id) => {
        setRescheduleData(prev => {
            const updated = { ...prev };
            delete updated[id]; // Or reset it with empty values: updated[id] = { rescheduledQuantity: "", rescheduleDate: "" }
            return updated;
        });
    };


    return (
        <div className={styless.profilebodyContainer}>
            <div className={styless.profileheader}>
                <h2>Reschedule Order</h2>
                <button className={styless.editbtn} onClick={() => navigate(-1)}>
                    Back to details
                </button>
            </div>
            <table className={styles.previewtable}>
                <thead>
                    <tr>
                        <th className={styles.previewth}>Part #</th>
                        <th className={styles.previewth}>Manufacture</th>
                        <th className={styles.previewth}>Pending QTY</th>
                        <th className={styles.previewth}>Required QTY</th>
                        <th className={styles.previewth}>Reschedule</th>
                    </tr>
                </thead>
                <tbody>
                    {data?.map((item) => (
                        <tr key={item.id} className={styles.previewstripedRow}>
                            <td className={styles.previewtd}>
                                <div style={{ display: 'flex', alignItems: "center", gap: "10px" }}>
                                    <ProductThumb src={item?.productId?.assets?.image?.[0]} />
                                    <div>
                                        {item?.productId?.productOverview?.productNumber?.[0] || item?.productNumber || "-"}
                                    </div>
                                </div>
                            </td>
                            <td className={styles.previewtd}>
                                {item?.productId?.productOverview?.manufacturer?.[0]?.name || item?.manufacturerName || "-"}
                            </td>
                            <td className={styles.previewtd}>
                                {item?.pendingOrderCount ?? item.quantity}
                            </td>
                            <td className={styles.previewtd}>
                                <input
                                    type="text"
                                    placeholder="Enter qty"
                                    className={styles.dataInput}
                                    value={
                                        rescheduleData[item._id]?.rescheduledQuantity !== undefined
                                            ? rescheduleData[item._id].rescheduledQuantity
                                            : ""
                                    }
                                    onChange={(e) => handleQuantityChange(e, item._id)}
                                />
                                {quantityErrors[item?._id] && (
                                    <div className={styles.errorText}>
                                        {quantityErrors[item?._id]}
                                    </div>
                                )}
                            </td>
                            <td className={styles.previewtd} style={{ display: 'flex', alignItems: 'center', gap: "10px" }}>
                                <div style={{ position: 'relative' }}>
                                    <ActionButton
                                        onClick={() => handleCalClick(item._id)}
                                        sx={{
                                            color: '#979797',
                                            border: '0.5px solid #9F9F9F',
                                            background: 'transparent',
                                            borderRadius: '6px',
                                            width: "190px",
                                            justifyContent: "flex-start",
                                            marginBottom: "9px"
                                        }}
                                    >
                                        {rescheduleData[item._id]?.rescheduleDate
                                            ? new Date(rescheduleData[item._id].rescheduleDate).toLocaleDateString()
                                            : "Select date"}
                                    </ActionButton>
                                    {showCalendar === item._id && (
                                        <div className="calendar" style={{ position: 'absolute', zIndex: 10 }}>
                                            <Calendar
                                                minDate={minRescheduleDate}
                                                onChange={(date) => handleDateChange(date.toISOString(), item._id)}
                                                value={rescheduleData[item._id]?.rescheduleDate || minRescheduleDate}
                                            />
                                        </div>
                                    )}
                                </div>
                                <div onClick={() => handleRefresh(item._id)} style={{ cursor: 'pointer' }}>

                                    <Refresh />
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className={styles.mainBtns}>
                <button className={styles.quoteBtn} onClick={handleCancel}>Cancel</button>
                <button className={styles.addBtn} onClick={handleDispatch} disabled={loading}>{loading ? "please wait.." : "Dispatch"}</button>
            </div>
        </div>
    );
};

export default Reschedulecomp;
